

























import { Component, Vue } from 'vue-property-decorator';

import { ErrorMessage } from '@/common/errors';
import { DailyReport } from '@/models/dailyReport.model';
import EntryForm from '@/pages/index/components/EntryForm.vue';
import IndexPageEditDialog from '@/pages/index/pages/index/components/IndexPageEditDialog.vue';
import { ConfigStore } from '@/store/config';
import { DailyReportStore, EDITOR_WIDTH } from '@/store/dailyReport';

@Component({
  components: {
    EntryForm,
    ErrorMessage,
    IndexPageEditDialog,
  },
})
export default class EditEntryPage extends Vue {

  @DailyReportStore.Bind.State('values') allReports!: DailyReportStore.State<'values'>;
  @ConfigStore.Bind.State processRolloverDate!: ConfigStore.State<'processRolloverDate'>;
  @DailyReportStore.Bind.Action delete!: DailyReportStore.Action<'delete'>;
  @DailyReportStore.Bind.Action update!: DailyReportStore.Action<'update'>;

  EDITOR_WIDTH = EDITOR_WIDTH;
  error = '';
  isRemoving = false;
  isSaving = false;
  reports: DailyReport[] = [];
  reportsInStore: DailyReport[] = [];

  created() {
    this.reportsInStore = this.allReports.filter(m => m.date === this.$route.params.date);
    this.reports = this.reportsInStore;
  }

  get isBeforeRollover() {
    return this.reports &&
           this.reports.length &&
           this.reports[0].date.localeCompare(this.processRolloverDate) < 0;
  }

  cancel() {
    this.goBack();
  }

  async remove() {
    this.error = '';
    this.isRemoving = true;

    try {
      const response = confirm('Are you sure you want to delete this entry?');
      if (response) {
        await this.delete({ reports: this.reports });
        this.goBack();
      }
    }
    catch (ex) {
      this.error = ex;
    }
    finally {
      this.isRemoving = false;
    }
  }

  async submit() {
    this.error = '';
    this.isSaving = true;

    try {
      await this.update({ oldReports: this.reportsInStore, newReports: this.reports });
      this.goBack();
    }
    catch (ex) {
      this.error = ex;
    }
    finally {
      this.isSaving = false;
    }
  }

  private goBack() {
    this.$router.go(-1);
  }

}
